import {
  AUTH_SOURCE_IRP,
  sessionStart,
  setTokens,
  postAuthTokenSuccess,
  fetchUser,
} from '@rsos/sinatra';
import { configureUserScope } from '@rsos/utils/sentry';
import packageJson from '../../package.json';
import handleRedirect from '../utils/handleRedirect';
import { setUserInfo } from './auth';

export const irpLogin = tokens => dispatch => {
  dispatch(sessionStart());
  // Marked here rather than at the callers because this is the one place every
  // IRP login passes through. An IRP token is issued with no refresh token by
  // design, and the marker is what lets the token-refresh paths tell that apart
  // from a session that lost a refresh token it should have had.
  setTokens({ ...tokens, auth_source: AUTH_SOURCE_IRP });
  dispatch(postAuthTokenSuccess(tokens));

  return dispatch(fetchUser())
    .then(res => {
      dispatch(setUserInfo(res));
      configureUserScope({
        email: res.profile.email,
        version: packageJson.version,
      });
      dispatch(handleRedirect);
    })
    .catch(err => {
      throw err;
    });
};
